import axios from 'axios';

const getArchivePackagesApi = () => {
	return axios.get(
		'https://backend.planmyleisure.com/package/get-archives'
	);
};

export default getArchivePackagesApi;
